import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { useFilterStore } from '@/helpers/composables/useStores';
import { FilterName } from '@/stores/filter.store';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetButton',
  props: {
    filterNames: { default: () => [] },
    updateRouteState: { type: Boolean, default: true },
    keepProvidersState: { type: Boolean, default: false },
    keepContentTypeState: { type: Boolean, default: false }
  },
  emits: ['resetClicked'],
  setup(__props: any, { emit: emits }) {

const props = __props as { filterNames: FilterName[], updateRouteState: boolean, keepProvidersState: boolean, keepContentTypeState: boolean };





const { reset, resetFilters } = useFilterStore();

function clickHandler() {
	// Note: Reset providers selection for SEO users, since we still use old Filters bar for SEO users
	emits('resetClicked');

	if (props.filterNames.length > 0) {
		resetFilters({ filterNames: props.filterNames, updateRouteState: props.updateRouteState });
	} else {
		reset({ keepProvidersState: props.keepProvidersState, keepContentTypeState: props.keepContentTypeState });
	}
}

return { __sfc: true,props, emits, reset, resetFilters, clickHandler, BasicButton, faTimes }
}

})